import React from 'react';
import { FaArrowLeft } from 'react-icons/fa';
import { useNavigate, useSearchParams } from 'react-router-dom';
import './PublicLayout.css';

const PublicLayout = ({ title, children, showBackButton = true }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const hideHeader = searchParams.get('noHeader') === 'true' && searchParams.get('mobileapp') === 'true';

  return (
    <div className="public-screen">
      {!hideHeader && (
        <div className="public-header">
          {showBackButton && (
            <button className="back-btn" onClick={() => navigate(-1)}>
              <FaArrowLeft />
            </button>
          )}
          <h1>{title}</h1>
        </div>
      )}
      
      <div className="public-container">
        <div className="content">
          {children}
        </div>
      </div>
    </div>
  );
};

export default PublicLayout;